<script setup lang="ts">
interface Props {
    link: string;
    title: string;
}
defineProps<Props>();
</script>

<template>
    <li class="cursor-pointer whitespace-nowrap text-truncate hover:bg-gray-400">
        <a
            :href="link"
            class="block px-4 py-2"
        >
            <slot />
            <span class="ml-4">{{ title }}</span>
        </a>
    </li>
</template>
